//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 504,
                    y: 668,
                    image: '/images/game/w4d2/game_1_internet_' + this.$lang.locale + '.png',
                    hintImage: '/images/game/w4d2/game_1_internet_hint_' + this.$lang.locale + '.png'
                },
                {
                    x: 547,
                    y: 197,
                    image: '/images/game/w4d2/game_1_wirtschaft_' + this.$lang.locale + '.png',
                    hintImage: '/images/game/w4d2/game_1_wirtschaft_hint_' + this.$lang.locale + '.png'
                },
                {
                    x: 633,
                    y: 196,
                    image: '/images/game/w4d2/game_1_wetter_' + this.$lang.locale + '.png',
                    hintImage: '/images/game/w4d2/game_1_wetter_hint_' + this.$lang.locale + '.png'
                },
                {
                    x: 676,
                    y: 282,
                    image: '/images/game/w4d2/game_1_medizin_' + this.$lang.locale + '.png',
                    hintImage: '/images/game/w4d2/game_1_medizin_hint_' + this.$lang.locale + '.png'
                },
                {
                    x: 891,
                    y: 282,
                    image: '/images/game/w4d2/game_1_verkehr_' + this.$lang.locale + '.png',
                    hintImage: '/images/game/w4d2/game_1_verkehr_hint_' + this.$lang.locale + '.png'
                }
            ]
        };
    }
};
